import BgRemover from './BgRemover'

export default BgRemover
